import React from 'react';
import { useTranslation } from 'react-i18next';
import LogoContainer from '../LogoContainer';
import { XIcon } from '../../../../SVG';
import { MobileStates, WidgetStateChangeType, WidgetStates } from '../../Widget';
import { THEME } from '../../../../clearstep/util/Theme';
import { getIntialStateIsHidden } from '../../../utils/Params';
import { useTranslationService } from '../../../../../util/i18n/TranslationServiceProvider';
import { WIDGET_NAMESPACE } from '../../../../../util/i18n/constants';
var Text = function () {
    var _a, _b;
    var t = useTranslation().t;
    var tService = useTranslationService().tService;
    return (React.createElement(React.Fragment, null,
        React.createElement("p", { className: "mb-1 text-2xl text-white opacity-70" }, t('widget.expandedGreeting.header', 'Welcome')),
        React.createElement("p", { className: "text-2xl font-medium text-white" }, ((_a = THEME.widgetCustomizations) === null || _a === void 0 ? void 0 : _a.expandedSubheaderText)
            ? tService((_b = THEME.widgetCustomizations) === null || _b === void 0 ? void 0 : _b.expandedSubheaderText, { ns: WIDGET_NAMESPACE })
            : t('widget.expandedGreeting.subeader', "Here's a few quick ways to find care"))));
};
export var ExpandedGreetingHeader = function (_a) {
    var setWidgetState = _a.setWidgetState, iconPath = _a.iconPath, mobileState = _a.mobileState;
    var initialState = getIntialStateIsHidden(mobileState)
        ? WidgetStates.HIDDEN
        : WidgetStates.COLLAPSED;
    return mobileState === MobileStates.MOBILE ? (React.createElement("div", { className: "bg-primary px-5 pb-[53px] pt-5" },
        React.createElement("div", { className: "flex justify-between pb-4" },
            iconPath ? React.createElement(LogoContainer, { sizeClasses: "w-8 h-8", iconPath: iconPath }) : React.createElement("div", null),
            React.createElement("button", { onClick: function () { return setWidgetState(initialState, WidgetStateChangeType.MANUAL); }, className: "tw-focus m-neg-2 " },
                React.createElement(XIcon, { className: "p-2" }))),
        React.createElement(Text, null))) : (React.createElement("div", { className: "rounded-t-md bg-primary" },
        React.createElement("div", { className: "flex justify-between px-5 pb-11 pt-6" },
            React.createElement("div", null,
                React.createElement(Text, null)),
            iconPath && React.createElement(LogoContainer, { sizeClasses: "w-10 h-10", iconPath: iconPath }))));
};
export default ExpandedGreetingHeader;
